import SpeedBonusConnection from '~/src/entities/speed-bonus';
import Context from '~/src/entities/vases/PartnerServices/Context';

import SubscriptionShowcase from './Showcase';

const Showcase = (): JSX.Element => {
    return (
        <Context>
            <SpeedBonusConnection>
                <SubscriptionShowcase/>
            </SpeedBonusConnection>
        </Context>
    );
};

export default Showcase;
